import { useForm, DefaultValues } from 'react-hook-form';
import type { UserCreate, UserUpdate } from '../types/user.types';
import { useCallback } from 'react';

export interface UseUserFormProps {
  defaultValues?: DefaultValues<UserCreate | UserUpdate>;
  onSubmit: (data: UserCreate | UserUpdate) => void;
}

export const useUserForm = ({ defaultValues, onSubmit }: UseUserFormProps) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
    setError,
    setValue,
  } = useForm<UserCreate | UserUpdate>({
    defaultValues: defaultValues || {
      name: undefined,
      email: undefined,
    },
  });

  const resetForm = useCallback(() => {
    reset();
  }, [reset]);

  const submitHandler = useCallback(
    (data: UserCreate | UserUpdate) => {
      onSubmit(data);
    },
    [onSubmit]
  );

  const formSubmitHandler = useCallback(() => {
    return handleSubmit(submitHandler);
  }, [handleSubmit, submitHandler]);

  return {
    control,
    errors,
    resetForm,
    formSubmitHandler,
    reset,
    setError,
    setValue,
  };
};
